import Vue from "vue";
import Vuex from "vuex";
import AppModule from "./App";
import UserModule from "./User";
import ReportModule from "./Report";
import FormModule from "./Form";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    App: AppModule,
    User: UserModule,
    Report: ReportModule,
    Form: FormModule
  }
});
